import { render, staticRenderFns } from "./RentabilidadeFornecedor.vue?vue&type=template&id=a0a179e4&scoped=true"
import script from "./RentabilidadeFornecedor.vue?vue&type=script&lang=js"
export * from "./RentabilidadeFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a179e4",
  null
  
)

export default component.exports